export default "__VITE_ASSET__C$wJmlW1__"